import React, { useEffect, useState } from 'react'
import { useForm, FormProvider } from "react-hook-form"
import { Box, Paper, Stack, Button, Collapse, Card, Grid, useTheme, } from "@mui/material"
import { Table, TableCell, TableHead, TableRow, TableBody, Pagination, TableContainer, MenuItem, Select, Checkbox, ListItemText, Typography } from '@mui/material';

import { useSelector } from 'react-redux';
import { getUser } from 'store/authSlice';
import { width } from '@mui/system';
import { useNavigate } from "react-router-dom";

import Loader from 'components/Loader';


import {
    ApiDashboardOverview,
    ApiFindDropdown,
    ApiDashboardAnalytics,
    ApiDashboardAnalyticsV1,
    ApiFindCheckList,
    ApiClearHistory,
    ApiOverviewUser,
    ApiOverviewUserTotal,

    ApiAnalyticsGraph,
    ApiAnalyticsData

} from 'utils/api/analytics'

import { ApiExportExcel }
    from 'utils/api/export'
// import TableCustom from 'utils/components/table-custom';
import TableCustom from 'utils/components/table-custom-v1';


import ColumnChart from 'utils/components/column-charts'
import PieChart from 'utils/components/pie-charts'
import moment from 'moment';

// import PieChartNormal from 'utils/components/chart/pie-chart'
import BarChartNormal from 'utils/components/chart/bar-chart'
import PieChartNormal from 'utils/components/chart/pie-chart-new'
import PieChartSummary from 'utils/components/chart/pie-chart-summary'



import DialogAlert from 'utils/components/modal-alert'
import DialogSubmit from 'utils/components/modal-submit'

function Index() {

    const navigate = useNavigate()

    const [typeSubmit, setTypeSubmit] = useState('')
    const [dataSubmit, setDataSubmit] = useState(null)

    const [openAlert, setOpenAlert] = useState(false)
    const [alertType, setAlertType] = useState('')
    const handleOpenAlert = (type) => {
        setOpenAlert(type)
    }
    const [openSubmit, setOpenSubmit] = useState(false)
    const handleOpenSubmit = async (type, reset, payload) => {
        setOpenSubmit(type)
        if (reset) {

            let filter = [{
                "type": "string",
                "field": "year",
                "start": year,
                "end": year
            }]
            if (ageGroupName && ageGroupName.length > 0) {
                filter.push({
                    "type": "string",
                    "field": "age_group",
                    "start": ageGroupName,
                    "end": ageGroupName
                })
            }

            if (['EXCEL'].includes(fileExport)) {
                let status = handleExportExcel('ex-graph-0015', filter, `excel-ผลตรวจร่างกายกำลังพลกลุ่มโรคไม่ติดต่อเรื้อรัง (NCDs)`)
                if (status) {
                    setFileExport('null')
                }

            }


            let result = await ApiClearHistory(payload)
            if (result.status) {
                setLoading(false)
                setMessageAlert('สำเร็จ')
                setAlertType('success')
                handleOpenAlert(true)
                setErrorMessage('');
                setTimeout(() => {
                    handleOpenAlert(false)
                    setMessageAlert('')
                    setAlertType('')
                }, 2000);

            }
            setTypeSubmit('')
        }
    }



    const [errorMessage, setErrorMessage] = useState('');
    const [messageAlert, setMessageAlert] = useState('')
    const [loading, setLoading] = useState(false)

    const [profile, setProfile] = useState('')
    const [findYear, setFindYear] = useState([])
    const [findDepartment, setFindDepartment] = useState([])
    const [findAgeGroup, setFindAgeGroup] = useState([])
    const [findMeasureGroup, setFindMeasureGroup] = useState([])




    const [year, setYear] = useState(moment(Date.now()).format('YYYY'))
    const [department, setDepartment] = useState('all')
    const [ageGroup, setAgeGroup] = useState('all')
    const [ageGroupName, setAgeGroupName] = useState(false)

    const [field, setField] = useState('bmi')


    const [exportFile, setExportFile] = useState(['EXCEL'])
    const [fileExport, setFileExport] = useState('null')


    const [selectedYear, setSelectedYear] = useState([]);
    const handleSelectChange = (event) => {
        const value = event.target.value;

        if (value.includes('all')) {
            if (selectedYear.length === findYear.length) {
                setSelectedYear([]);
            } else {
                const allValues = findYear.map(element => element.i_code);
                setSelectedYear(allValues);
            }
        } else {
            setSelectedYear(value);
        }
    };



    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [page, setPage] = useState(1)
    const [alertData, setAlertData] = useState([]);


    const [findChecklist, setFindChecklist] = useState([])
    const [configHead, setConfigHead] = useState([
        { name: "ชื่อ นามสกุล", minWidth: "220px", align: 'left' },
        { name: "สังกัด", minWidth: "160px", align: 'left' }

    ])
    const [configBody, setConfigBody] = useState([
        { name: 'full_name', align: 'left' },
        { name: 'department_name', align: 'left' }

    ])






    const user = useSelector(getUser);


    const [findOverviewUser, setFindOverviewUser] = useState(null)
    const [findOverviewUserTotal, setFindOverviewUserTotal] = useState(null)

    const [pageOverviewUser, setPageOverviewUser] = useState(1)
    const [rowsPerPageOverviewUser, setRowsPerPageOverviewUser] = useState(10)

    const [findOverviewTable, setFindOverviewTable] = useState(null)
    const [pageOverviewTable, setPageOverviewTable] = useState(1)
    const [rowsPerPageOverviewTable, setRowsPerPageOverviewTable] = useState(10)


    const [findOverview, setFindOverview] = useState(null)
    const [findBMIAnalytics, setFindBMIAnalytics] = useState(null)
    const [findNCDsAnalytics, setFindNCDsAnalytics] = useState(null)
    const [findSummaryAnalytics, setFindSummaryAnalytics] = useState(null)

    const [findDataAnalytics, setFindDataAnalytics] = useState([])





    const methods = useForm({
        defaultValues: {

        },
    });


    useEffect(() => {

        fetchData()
    }, [])



    useEffect(() => {
        fetchOverviewUser()
    }, [year, selectedYear, department, pageOverviewUser, rowsPerPageOverviewUser])


    useEffect(() => {
        fetchTableAnalytics()
    }, [year, selectedYear, department, pageOverviewTable, rowsPerPageOverviewTable])



    useEffect(() => {
        fetchDataAnalytics()
    }, [year, selectedYear, department])

    useEffect(() => {
        fetchTableAnalytics()
    }, [ageGroup])


    useEffect(() => {
        fetchGraphAnalytics()
    }, [year, ageGroup, field])

    const handleChange = (type, e) => {
        if (type === 'year') {
            setYear(e.target.value)
        } else if (type === 'department') {
            setDepartment(e.target.value)
        } else if (type === 'ageGroup') {
            let findAgeGroupName = findAgeGroup.find(d => d.i_code === e.target.value)
            if (findAgeGroupName) {
                setAgeGroupName(findAgeGroupName.i_name)
            }
            setAgeGroup(e.target.value)
        } else if (type === 'field') {
            setField(e.target.value)
        }
    }




    const fetchData = async () => {
        ApiFindDropdown('year').then(res => {
            if (res.status) {
                setFindYear(res.data)
            } else {
                setFindYear([])
            }
        })

        ApiFindDropdown('department').then(res => {
            if (res.status) {
                setFindDepartment(res.data)
            } else {
                setFindDepartment([])
            }
        })

        ApiFindDropdown('age_group').then(res => {
            if (res.status) {
                setFindAgeGroup(res.data)
            } else {
                setFindAgeGroup([])
            }
        })

        ApiFindDropdown('measure_value').then(res => {
            if (res.status) {
                setFindMeasureGroup(res.data)
            } else {
                setFindMeasureGroup([])
            }
        })


        ApiFindCheckList().then(res => {
            if (res && res.length > 0) {
                res.forEach(element => {
                    configHead.push({ name: element.field_name, minWidth: "160px", align: 'center' })
                    configBody.push({ name: element.field, align: 'center' })
                });
                setConfigHead(configHead)
                setConfigBody(configBody)
                setFindChecklist(res)
            } else {
                setFindChecklist([])
            }
        })
    }


    const fetchOverviewUser = async () => {

        ApiOverviewUser({ year: year === 'all' ? 'all' : year, department_code: department === 'all' ? 'all' : department, page: pageOverviewUser, limit: rowsPerPageOverviewUser }).then(res => {
            if (res.status) {
                setFindOverviewUser(res.data)

            } else {
                setFindOverviewUser(null)

            }
        })

        ApiOverviewUserTotal({ year: year === 'all' ? 'all' : year }).then(res => {
            if (res.status) {

                setFindOverviewUserTotal(res.data)

            } else {
                setFindOverviewUserTotal(null)

            }
        })
    }

    const fetchTableAnalytics = async () => {
        ApiAnalyticsData('ncds', { year: year === 'all' ? 'all' : year, limit: rowsPerPageOverviewTable, page: pageOverviewTable, department_code: department === 'all' ? null : department }).then(res => {
            if (res.status) {
                setFindOverviewTable(res)
            } else {
                setFindOverviewTable(null)
            }
        })

        ApiAnalyticsGraph('ncds', {
            year: year === 'all' ? 'all' : year,
            age: ageGroup === 'all' ? 'all' : ageGroup
        }).then(res => {
            if (res.status) {
                setFindNCDsAnalytics(res.data)
            } else {
                setFindNCDsAnalytics(null)
            }
        })

    }

    const fetchGraphAnalytics = async () => {
        setFindSummaryAnalytics(null)
        ApiAnalyticsGraph(field, { year: year, age: ageGroup === 'all' ? null : ageGroup }).then(res => {
            if (res.status) {
                setFindSummaryAnalytics(res.data)
            } else {
                setFindSummaryAnalytics(null)
            }
        })

        // ApiAnalyticsGraph('summary', {
        //     year: year === 'all' ? 'all' : year,
        //     age: ageGroup === 'all' ? 'all' : ageGroup,
        //     field:field === 'all' ? 'all' : field
        // }).then(res => {
        //     if (res.status) {
        //         setFindSummaryAnalytics(res.data)
        //     } else {
        //         setFindSummaryAnalytics(null)
        //     }
        // })

    }

    const fetchDataAnalytics = async () => {
        ApiDashboardOverview({ year: year === 'all' ? 'all' : year, }).then(res => {
            if (res.status) {
                setFindOverview(res.data)
            } else {
                setFindOverview({})
            }
        })

        ApiDashboardAnalyticsV1('bmi', { year: year === 'all' ? 'all' : year, }).then(res => {
            if (res.status) {
                setFindBMIAnalytics(res.data)
            } else {
                setFindBMIAnalytics({})
            }
        })

        // ApiDashboardAnalyticsV1('ncds', { year: year === 'all' ? 'all' : year, department_code: department === 'all' ? 'all' : department }).then(res => {
        //     if (res.status) {
        //         setFindNCDsAnalytics(res.data)
        //     } else {
        //         setFindNCDsAnalytics({})
        //     }
        // })
    }





    const handlemore = (type, payload) => {
        if (type === 'VIEW') {
            window.open(`https://microservice-smarthealth.mod.go.th/healthsystem-uat-report/documents/checkup/?doc_code=EL-11&pid=${payload.pid}`, '_blank')

        } else if (type === 'EDIT') {
            navigate(`/editPersonalHealthData/?pid=${payload.pid}&year=${payload.year}&inspection_round=${payload.inspection_round}&department_code=${payload.department_code}&hospital_code=${payload.hospital_code}&type=${type}`);
            // window.open(`/editPersonalHealthData/?pid=${payload.pid}&year=${payload.year}&inspection_round=${payload.inspection_round}&type=${type}`, '_blank')
        } else if (type === 'DELETE') {

            setDataSubmit({
                pid: payload.pid,
                year: payload.year,
                inspection_round: payload.inspection_round,
                department_code: payload.department_code,
                hospital_code: payload.hospital_code,
            })
            handleOpenSubmit(true, false)
            setTypeSubmit('ยืนยันการลบ ?')
            // window.open(`/editPersonalHealthData/?pid=${payload.pid}&year=${payload.year}&inspection_round=${payload.inspection_round}&type=${type}`, '_blank')

        }
    }



    const handleAlert = () => {

    }



    const handleChartNormal = (type) => {

        console.log("type  ", type);


    }

    const handleChartSummary = (type) => {

    }



    useEffect(() => {


        if (fileExport === 'EXCEL') {
            handleOpenSubmit(true)
            setTypeSubmit('ผลตรวจร่างกายกำลังพลกลุ่มโรคไม่ติดต่อเรื้อรัง (NCDs)')
        }

    }, [fileExport])



    const handleExportExcel = async (excel_code, filter, file_name) => {

        let result = await ApiExportExcel({
            "export_code": excel_code,
            "file_name": file_name,
            "filter": filter
        })

        if (result?.status) {

            let { file_url } = result.data

            // Create a hidden anchor element for downloading the file
            const link = document.createElement('a');
            link.href = file_url;
            link.download = ''; // Optional: specify a custom filename
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            return true

        } else {
            return false

        }





    }


    console.log("ageGroupName : ", ageGroupName);

    return (
        <Box sx={{ margin: "4px", flex: 1 }}>
            <Loader loading={loading} />

            <FormProvider {...methods}>
                <Paper
                    sx={{
                        p: "10px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "5px",
                        flex: 1,
                        overflow: "hidden",
                    }}
                >




                    <Grid container spacing={2}>

                        <Grid item xs={4} md={3}>

                            <Box sx={{ fontWeight: 600, pl: 4, }}>เลือกปี</Box>
                            <Box sx={{

                                pl: 4,
                                pb: 4,
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                // borderRadius: '4px', // Optional, for rounded corners
                                // padding: '8px', // Adjust padding as needed
                            }}>
                                <Select
                                    size="small"
                                    value={year || "null"}
                                    onChange={(e) => { handleChange('year', e) }}
                                    sx={{
                                        backgroundColor: '#C8EBEB',
                                        border: 'none',
                                        '.MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#C8EBEB',
                                        },
                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#C8EBEB',
                                        },
                                        '&:hover .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#C8EBEB',
                                        },
                                        width: '100%', // Ensure the Select fills the Box width
                                    }}
                                >


                                    {findYear.map((i, idx) => (
                                        <MenuItem key={idx} value={i['i_code']}>{i['i_name']}</MenuItem>
                                    ))}
                                </Select>
                            </Box>
                        </Grid>



                    </Grid>

                    <Grid item xs={12} md={12}>

                        <Box
                            sx={{
                                // height: '670px',
                                // border: '1px solid #478F96',
                                // borderRadius: '10px',
                                // display: 'flex',
                                justifyContent: 'center', // Center content horizontally
                                alignItems: 'center',    // Center content vertically

                            }}
                        >
                            <TableCustom
                                data={{
                                    data: findOverviewUserTotal,
                                    // pagging: findOverviewUser?.pagging
                                }}
                                // onSelected
                                // selected={select}
                                // setSelected={handleSelect}
                                // page={pageOverviewUser}
                                // setPage={setPageOverviewUser}
                                // rowsPerPage={rowsPerPageOverviewUser}
                                // setRowsPerPage={setRowsPerPageOverviewUser}
                                // listMore={['VIEW']}
                                // more={true}
                                // handlemore={handlemore}
                                pagination={false}
                                sx={{ height: "100%" }}
                                head={[
                                    { name: "", width: "120px", align: 'left' },
                                    { name: "จำนวนกำลังพล ", name2: '(ตรวจแล้ว/ทั้งหมด', width: "40px", align: 'right' },
                                    { name: "ร้อยละ ", name2: '(ตรวจแล้ว/ทั้งหมด)', width: "200px", align: 'left' },
                                ]}
                                // header={false}
                                body={[
                                    { name: 'group_name', align: 'left', type: 'department' },
                                    { name: 'total_user', align: 'right', type: 'personnel' },
                                    { name: 'total_checkup_percentage', align: 'right', type: 'percentage-total' },

                                ]}
                            />

                        </Box>

                        <Box
                            sx={{
                                pb: 2
                            }}
                        >

                        </Box>

                        <Box
                            sx={{
                                height: '670px',
                                border: '1px solid #478F96',
                                borderRadius: '10px',
                                // display: 'flex',
                                justifyContent: 'center', // Center content horizontally
                                alignItems: 'center',    // Center content vertically

                            }}
                        >
                            <TableCustom
                                data={{
                                    data: findOverviewUser?.data,
                                    pagging: findOverviewUser?.pagging
                                }}
                                // onSelected
                                // selected={select}
                                // setSelected={handleSelect}
                                page={pageOverviewUser}
                                setPage={setPageOverviewUser}
                                rowsPerPage={rowsPerPageOverviewUser}
                                setRowsPerPage={setRowsPerPageOverviewUser}
                                // listMore={['VIEW']}
                                // more={true}
                                // handlemore={handlemore}
                                pagination={true}
                                sx={{ height: "100%" }}
                                head={[
                                    { name: "หน่วยงาน", width: "120px", align: 'left' },
                                    { name: "จำนวนกำลังพล ", name2: '(ตรวจแล้ว/ทั้งหมด', width: "40px", align: 'right' },
                                    { name: "ร้อยละ ", name2: '(ตรวจแล้ว/ทั้งหมด)', width: "200px", align: 'left' },
                                ]}
                                body={[
                                    { name: 'department_name', align: 'left', type: 'department' },
                                    { name: 'total_user', align: 'right', type: 'personnel' },
                                    { name: 'total_checkup_percentage', align: 'right', type: 'percentage' },

                                ]}
                            />

                        </Box>

                    </Grid>


                    <Box
                        sx={{
                            pt: 4,
                            pb: 4,
                            display: 'grid',
                            columnGap: 3,
                            rowGap: 1,
                            gridTemplateColumns: 'repeat(2, 1fr)', // Two equal columns
                        }}
                    >
                        <Box
                            // key={index} // Unique key for each item
                            sx={{
                                height: '450px',
                                border: '1px solid #478F96',
                                borderRadius: '10px',
                                // display: 'flex',
                                justifyContent: 'center', // Center content horizontally
                                alignItems: 'center',    // Center content vertically
                                pt: 5,
                                pb: 5,
                                pr: 5,
                                pl: 5
                            }}
                        >
                            <BarChartNormal
                                title={'จำนวนแยกตามเพศ'}
                                data={findOverview?.data_group_by_gender ? findOverview?.data_group_by_gender : []}
                                color={findOverview?.color_gender ? findOverview?.color_gender : null}
                                export_file={['EXCEL', 'PNG']}
                                export_code='ex-graph-0012'
                                // filter={[{
                                //     "type": "string",
                                //     "field": "year",
                                //     "start": year,
                                //     "end": year
                                // }]}
                                filter={[]}
                            />
                        </Box>

                        <Box
                            // key={index} // Unique key for each item
                            sx={{
                                height: '450px',
                                border: '1px solid #478F96',
                                borderRadius: '10px',
                                // display: 'flex',
                                justifyContent: 'center', // Center content horizontally
                                alignItems: 'center',    // Center content vertically
                                pt: 5,
                                pb: 5,
                                pr: 5,
                                pl: 5
                            }}
                        >
                            <BarChartNormal
                                title={'จำนวนแยกตามช่วงอายุ'}
                                data={findOverview?.data_group_by_age}
                                color={findOverview?.color_age ? findOverview?.color_age : null}
                                export_file={['EXCEL', 'PNG']}
                                export_code='ex-graph-0013'
                                // filter={[{
                                //     "type": "string",
                                //     "field": "year",
                                //     "start": year,
                                //     "end": year
                                // }]}
                                filter={[]}
                            />
                        </Box>

                    </Box>




                    <Box
                        sx={{
                            height: '550px',
                            border: '1px solid #478F96',
                            borderRadius: '10px',
                            // display: 'flex',
                            justifyContent: 'center', // Center content horizontally
                            alignItems: 'center',    // Center content vertically
                            pt: 5,
                            pb: 5,
                            pr: 5,
                            pl: 5

                        }}
                    >


                        <PieChartNormal
                            data_dropdown={findAgeGroup}
                            title={'ผลตรวจกำลังพลกลุ่มโรคไม่ติดต่อเรื้อรัง (NCDs)'}
                            data={findNCDsAnalytics?.data_list ? findNCDsAnalytics?.data_list : []}
                            color={findNCDsAnalytics?.color_list ? findNCDsAnalytics?.color_list : null}
                            handleChange={handleChange}
                            select={ageGroup}
                            export_file={['EXCEL', 'PNG']}
                            export_code='ex-graph-0001'
                            filter={[{
                                "type": "string",
                                "field": "year",
                                "start": year,
                                "end": year
                            },
                            ...(ageGroupName && ageGroupName.length > 0 ? [{
                                "type": "string",
                                "field": "age_group",
                                "start": ageGroupName,
                                "end": ageGroupName
                            }] : [])]}
                        />



                    </Box>


                    <Box
                        sx={{
                            pt: 4,
                            pb: 4,
                            display: 'grid',
                            columnGap: 3,
                            rowGap: 1,
                            gridTemplateColumns: 'repeat(1, 1fr)', // Single column layout
                        }}
                    >
                        <Box
                            sx={{
                                // height: '20px',
                                justifyContent: 'center',
                                alignItems: 'center',
                                pt: 2,
                                pb: 2,
                                pr: 5,
                                pl: 5,
                                position: 'relative', // Needed for absolute positioning of the Select
                            }}
                        >
                            {exportFile && exportFile.length > 0 ? (
                                <Select
                                    size="small"
                                    value={fileExport || ""}
                                    onChange={(e) => setFileExport(e.target.value)}
                                    sx={{
                                        position: 'absolute',
                                        top: 8,
                                        left: 8, // ชิดซ้าย
                                        backgroundColor: '#C8EBEB',
                                        border: 'none',
                                        zIndex: 10,
                                        '.MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#C8EBEB',
                                        },
                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#C8EBEB',
                                        },
                                        '&:hover .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#C8EBEB',
                                        },
                                    }}
                                >
                                    <MenuItem value="null" disabled>
                                        Export Raw Data
                                    </MenuItem>
                                    {exportFile.map((i, idx) => (
                                        <MenuItem key={idx} value={i}>
                                            {i}
                                        </MenuItem>
                                    ))}
                                </Select>
                            ) : (
                                <>No export files available</>
                            )}
                        </Box>
                    </Box>


                    <Box
                        sx={{

                            display: 'grid',
                            columnGap: 3,
                            rowGap: 1,
                            gridTemplateColumns: 'repeat(1, 1fr)', // Two equal columns
                        }}
                    >



                        <TableCustom
                            data={{
                                data: findOverviewTable?.data,
                                pagging: findOverviewTable?.pagging
                            }}
                            more={true}
                            listMore={['EDIT', 'DELETE']}
                            handlemore={handlemore}
                            // onSelected
                            // selected={select}
                            // setSelected={handleSelect}
                            // handlemore
                            // more={true}
                            // listMore={['VIEW', 'EDIT']}
                            // handlemore={handlemore}

                            page={pageOverviewTable}
                            setPage={setPageOverviewTable}
                            rowsPerPage={rowsPerPageOverviewTable}
                            setRowsPerPage={setRowsPerPageOverviewTable}
                            pagination={true}
                            sx={{ height: "100%" }}
                            head={configHead}
                            body={configBody}
                        />
                    </Box>





                    <Box
                        sx={{
                            height: '550px',
                            border: '1px solid #478F96',
                            borderRadius: '10px',
                            // display: 'flex',
                            justifyContent: 'center', // Center content horizontally
                            alignItems: 'center',    // Center content vertically
                            pt: 5,
                            pb: 5,
                            pr: 5,
                            pl: 5

                        }}
                    >


                        <PieChartSummary
                            data_age_group={findAgeGroup}
                            data_measure_group={findMeasureGroup}
                            title={'ผลตรวจกำลังพลทั้งหมดในสังกัด สป.'}
                            data={findSummaryAnalytics?.data_list ? findSummaryAnalytics?.data_list : []}
                            color={findSummaryAnalytics?.color_list ? findSummaryAnalytics?.color_list : null}
                            handleChange={handleChange}
                            select={ageGroup}
                            select1={field}
                            export_file={['EXCEL', 'PNG']}
                            export_code='ex-graph-0001'
                            filter={[
                                {
                                    "type": "string",
                                    "field": "year",
                                    "start": year,
                                    "end": year
                                },
                                ageGroupName && {
                                    "type": "string",
                                    "field": "age_group",
                                    "start": ageGroupName,
                                    "end": ageGroupName
                                }
                            ]}
                        />


                    </Box>

                </Paper>
                <DialogAlert
                    loading={loading}
                    title={'แจ้งเตือน'}
                    type={alertType}
                    message={messageAlert}
                    open={openAlert}
                    setOpen={setOpenAlert}
                    handleChange={handleAlert}
                    data={alertData}

                />

                <DialogSubmit
                    title={`${typeSubmit}`}
                    open={openSubmit}
                    setOpen={setOpenSubmit}
                    handleOpenSubmit={handleOpenSubmit}
                    data={dataSubmit}
                />


            </FormProvider>
        </Box>

    )
}

export default Index
